import React, { useState, useEffect, useContext, useRef } from 'react';
import { ThemeContext } from "../../Layout/Theme/ThemeContext";
import { useNavigate } from 'react-router-dom';
import SaleOrderService from "../Controller/SaleOrderController";
import SaleOrderDetailModal from "./SaleOrderDetail";
import Common from '../../Common/Common';
import $ from 'jquery';
import 'datatables.net-bs5';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import Swal from 'sweetalert2';
import HelpSite from "../../Common/HelpLink";
import ShipSaleOrder from "./SaleOrderForms/ShipSaleOrder";
import SaleOrderShippedModel from "./SaleOrderForms/SaleOrderShippedModel";
import ModuleService from "../../Setup/controller/ModuleController/ModuleController";
import SageService from '../../Sage/Controller/SageController';
import Draggable from 'react-draggable';
import { useTranslation } from 'react-i18next';
import ColumnOptionDropDown from "../../Lead/Views/LeadForms/ColumnOptionDropDown";
import Cookies from "js-cookie";
import { formatDateWithFns } from '../../Common/DateInputFormat';
import useDateFormat from '../../Common/fetchDateFormat';
import LockReleaseService from "../../Setup/controller/LockReleaseController/LockModuleController";
import CompanySetupController from "../../SuperAdmin/Controller/Client/SACompanyListController";
import QuickbookService from '../../Quickbook/QuickbookController';
import XeroService from '../../Xero/XeroController';
import SendEmail from "../../Common/SendEmail";
import MultipleEmail from "../../Common/MultipleEmail";
import CustomerService from "../../Customer/Controller/CustomerController";
import MultiSearchDropDown from "../../Common/MultiSearchDropDown";

import JasperReportService from '../../Dashboard/Controller/JasperReportController';
import axiosInstance from '../../../config/axiosInstance';

import SendAttachment from "../../Common/SendAttachment";
import ReportService from "../../Setup/controller/ReportController/ReportController";
import TermsConditionService from "../../Setup/controller/TermsConditionController/TermsConditionController";
import BASE_URL from "../../../config/config";
import { PDFDocument } from "pdf-lib";
function SaleOrderList({ ClientCompanyID, JobTab }) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };
  const tableRef = useRef();
  const [modalInstance, setModalInstance] = useState(null);
  const { theme, toggleTheme } = useContext(ThemeContext);
  let accordTheme = "accordion-header-light";
  if (theme == "dark") {
    accordTheme = "accordion-header-dark";
  }
  const [SaleOrderList, setSaleOrderData] = useState([]);
  const [showAssetDetailModal, setShowAssetDetailModal] = useState(false); // State to control AssetDetailModal visibility
  const [modalInstanceSaleOrderDetail, setModalInstanceSaleOrderDetail] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedId, setSelectedId] = useState("0");
  const [StockLocationList, setStockLocation] = useState([]);
  const [partList, setPartData] = useState([]);
  const [showShippedModal, setShowShippedModal] = useState(false);
  const [bnt_OrderNumber, set_bnt_OrderNumber] = useState("");
  const [saleOrderId, setSaleOrderID] = useState("");
  const [SaleOrderBalance, setSaleOrderBalance] = useState();
  const [isModalBalance, setIsModalBalance] = useState(false);
  const [currentPage, setCurrentPage] = useState(1); // Current page
  const [totalPages, setTotalPages] = useState(1); // Total number of pages
  const [searchQuery, setSearchQuery] = useState('');
  const [soCount, setSOCount] = useState(0);
  const [multipleIds, setMultipleIds] = useState([]);
  const UserID = localStorage.getItem("UserID");
  const CompanyID = localStorage.getItem("CompanyID");
  const [recentSearches, setRecentSearches] = useState([]);
  const activeDateFormat = useDateFormat();
  const [pdfAttachment, setPdfAttachment] = useState(null);
  const setSortConfigInCookie = (config) => {
    Cookies.set(`SaleOrderSort_${CompanyID}_${UserID}`, JSON.stringify(config), { expires: 365 });
  };
  const getSortConfigFromCookie = () => {
    const sortCookie = Cookies.get(`SaleOrderSort_${CompanyID}_${UserID}`);
    return sortCookie ? JSON.parse(sortCookie) : { key: 'PK_SalesOrder_ID', direction: 'desc' };
  };
  const [sortConfig, setSortConfig] = useState(getSortConfigFromCookie());

  const setPageSizeInCookie = (pageSize) => {
    document.cookie = `pageSize=${pageSize};path=/;max-age=31536000`; // 1 year
  };
  const getPageSizeFromCookie = () => {
    const match = document.cookie.match(new RegExp('(^| )pageSize=([^;]+)'));
    return match ? parseInt(match[2], 10) : 10; // Default to 10 if no cookie is found
  };
  const [pageSize, setPageSize] = useState(getPageSizeFromCookie());
  const redirectCallback = () => {
    navigate('/'); // Redirect to the login page
  };

  async function fetchSearchLog() {
    try {

      const searchList = await CustomerService.GetSearchLog("7");
      setRecentSearches(searchList);
    } catch (error) {
      console.error('Error fetching Roles:', error);
    }
  }

  const fetchSaleOrder = async (ClientCompanyID, page, size) => {
    try {

      setLoading(true);
      const Start = Math.round((parseInt(page) * parseInt(size)) - (size - 1)).toString();
      const PageSize = size.toString();

      const data = await SaleOrderService.GetAllSaleOrder(redirectCallback, ClientCompanyID, Start.toString(), PageSize.toString(),
        searchQuery.toString(), sortConfig.key.toString(), sortConfig.direction.toString(), searchColumns.toString());

      setSaleOrderData(data);

      const sarderCount = await SaleOrderService.GetSaleOrderCount(redirectCallback, ClientCompanyID, searchQuery.toString(), searchColumns.toString());
      setSOCount(sarderCount[0].TotalRecords);
      setTotalPages(Math.ceil(sarderCount[0].TotalRecords / size));
    } catch (error) {
      console.error('Error fetching Teams:', error);
    } finally {
      setLoading(false); // Stop loading after fetching
    }
  };
  const UserLockRelease = async () => {
    try {
      const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
      };
      const CompanyID = localStorage.getItem("CompanyID");
      if (CompanyID === null || CompanyID === "null") {
        redirectCallback();
      }
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "2");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "3");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "4");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "5");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "6");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "7");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "8");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "9");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "10");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "15");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "17");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "18");

    } catch (error) {
      console.error('Error fetching Teams:', error);
    }
  };
  useEffect(() => {
    fetchSaleOrder(ClientCompanyID, currentPage, pageSize);
  }, [ClientCompanyID, currentPage, pageSize]);
  useEffect(() => {
    fetchSaleOrder(ClientCompanyID, currentPage, pageSize);
  }, [ClientCompanyID, sortConfig]);
  useEffect(() => {
    IsModuleAssigned();
    UserLockRelease();
    fetchSearchLog();
    fetchSaleOrder(ClientCompanyID, '0', pageSize);
  }, [ClientCompanyID, JobTab]);

  const handleCloseModal = async (isChanged) => {


    const closeModal = async () => {
      await SaleOrderService.UnLockSaleOrder(localStorage.getItem('SaleOrderID'));
      if (localStorage.getItem('HasRecordUpdated') == "1") {
        await fetchSaleOrder(ClientCompanyID, '0', pageSize);
      }
      setMultipleIds([]);
      setIsModalOpen(false);
    };

    if (isChanged != true) {
      closeModal();
      return;
    }

    Swal.fire({
      title: 'Are you sure?',
      text: `Are you sure you want to close this record?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, close it!'
    }).then(async (result) => {
      if (result.isConfirmed) {
        closeModal();
      }
    });
  };

  const handleDeleteClick = async (event) => {
    event.stopPropagation(); // Prevent the row click event
    if (multipleIds.length > 0) {
      Swal.fire({
        title: 'Are you sure?',
        text: `You are about to delete ${multipleIds.length} record(s). This cannot be undone!`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            await SaleOrderService.DeleteSaleOrder(multipleIds);
            setMultipleIds([]);
            await fetchSaleOrder(ClientCompanyID, '0', pageSize);
            setSelectedId("0");
            Swal.fire(
              'Deleted!',
              'Your record has been deleted.',
              'success'
            );
          } catch (error) {
            console.error('Error deleting job:', error);
            Swal.fire(
              'Error!',
              'There was a problem deleting the record.',
              'error'
            );
          }
        }
      });
    }
    else {
      Swal.fire(
        'Error!',
        'Please check at least one record to delete sales order.',
        'warning'
      );
    }
  };
  const handleCreateSaleOrderClick = () => {
    localStorage.setItem('SaleOrderID', "");
    localStorage.setItem('SaleOrderID', "0");
    localStorage.setItem('HasRecordUpdated', "0");
    setIsModalOpen(true);
  };
  const handleEditClick = async (SaleOrderID) => {
    const IsAlreadyLeadID = localStorage.getItem('SaleOrderID');
    if (IsAlreadyLeadID) {
      await SaleOrderService.UnLockSaleOrder(IsAlreadyLeadID);
    }
    const saleOrderDetail = await fetchSaleOrderDetail(SaleOrderID);
    if (saleOrderDetail) {

      localStorage.setItem('SaleOrderID', "");
      localStorage.setItem('SaleOrderID', SaleOrderID);
      localStorage.setItem('HasRecordUpdated', "0");
      setSelectedId(SaleOrderID);
      setIsModalOpen(true);

    }
  };
  const truncateText = (text, maxLength = 15) => {
    if (!text) return '';  // Return empty string if text is null or empty
    return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
  };

  // Allocate and ship sales order
  const fetchSaleOrderDetail = async (SaleOrderID) => {
    try {
      const redirectCallback = () => navigate('/');
      if (SaleOrderID > 0) {
        const saleOrderDetail = await SaleOrderService.GetSaleOrderByID(redirectCallback, SaleOrderID);
        const saleOrder = saleOrderDetail[0];
        return saleOrder;
      }
    } catch (error) {
      console.error('Error fetching agreement details:', error);
    }
  };
  const handleCheckboxChange = (event, id) => {
    event.stopPropagation();
    setSelectedId((prevSelectedId) => (prevSelectedId === id ? "0" : id)); // Toggle selection
    setMultipleIds((prevSelectedIds) => {
      if (event.target.checked) {
        return [...prevSelectedIds, id];
      } else {
        return prevSelectedIds.filter((selectedId) => selectedId !== id);
      }
    });
  };
  //----------------------------------------------------------------------------------------
  const handleSuccess = async () => {
    setShowShippedModal(false);
    await fetchSaleOrder(ClientCompanyID, '0', pageSize);
  };


  const { handleShipSaleOrder } = ShipSaleOrder(selectedId);

  const handleAllocateSaleOrder = async (event, part, index) => {
    event.stopPropagation();
    let ID = 0;
    for (const id of multipleIds) {
      ID = id;
    }
    if (ID > 0) {
      const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
      };
      const saleOrderDetail = await fetchSaleOrderDetail(ID);


      if (saleOrderDetail.snt_AllocatedStatus === 2) {
        Swal.fire(
          '',
          'The Selected Sales Order is already allocated',
          'Warning'
        );
      }
      else {
        if (saleOrderDetail.ContractSaleOrder > 0) {
          Swal.fire(
            '',
            'The Selected Sales Order can not be shipped as this order is generated from the Agreement',
            'Warning'
          );
        }
        else {

          let SaleOrderItem = await SaleOrderService.GetSaleOrderItem(redirectCallback, ID);
          SaleOrderItem = SaleOrderItem.filter(x => x.FK_Stock_ID > 0);
          if (SaleOrderItem.length > 0) {
            if (saleOrderDetail.bit_DropShipment === 2 || saleOrderDetail.snt_AllocatedStatus === 2) {
              Swal.fire(
                '',
                'The Selected Sales Order is already allocated or shipped',
                'Warning'
              );
            }
            else {
              Swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, allocate it!'
              }).then(async (result) => {
                if (result.isConfirmed) {
                  try {
                    setPartData([]);
                    setShowShippedModal(true);
                    debugger;
                    set_bnt_OrderNumber(saleOrderDetail.bnt_OrderNumber);
                    setSaleOrderID(ID);
                    const SaleOrderItemList = await handleShipSaleOrder(event, ID);
                    setPartData(SaleOrderItemList);

                  } catch (error) {

                  }
                }
              });
            }
          }
          else {
            Swal.fire(
              'Error!',
              'The selected sales order cannot be allocated because no stock items are available.',
              'warning'
            );
          }
        }
      }
    }
    else {
      Swal.fire(
        'Error!',
        'Please check at least one record to allocate sales order.',
        'warning'
      );
    }


  }
  const handleShippment = async (event, part, index) => {
    event.stopPropagation();
    let ID = 0;
    for (const id of multipleIds) {
      ID = id;
    }
    if (ID > 0) {
      const saleOrderDetail = await fetchSaleOrderDetail(ID);
      let SaleOrderItem = await SaleOrderService.GetSaleOrderItem(redirectCallback, ID);
      SaleOrderItem = SaleOrderItem.filter(x => x.FK_Stock_ID > 0);
      debugger;
      if ((saleOrderDetail.snt_AllocatedStatus === 0 || saleOrderDetail.snt_AllocatedStatus === null) && SaleOrderItem.length > 0) {
        Swal.fire(
          '',
          'Please allocate the selected sales order first and then shipped.',
          'Warning'
        );
      }
      else {
        if (saleOrderDetail.bit_DropShipment === 2) {
          Swal.fire(
            '',
            'The Selected Sales Order is already shipped',
            'Warning'
          );
        }
        else {
          Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, ship it!'
          }).then(async (result) => {
            if (result.isConfirmed) {
              try {

                if (SaleOrderItem.length > 0) {
                  const postData = await SaleOrderService.ShipSaleOrder(ID);
                  if (postData.message === "Data saved successfully") {
                    Swal.fire(
                      '',
                      'The Sales order shipped successfully.',
                      'success'
                    );
                    handleSuccess();
                  }
                }
                else {
                  const postData = await SaleOrderService.SaleOrderNonStockShipment(ID);
                  if (postData.message === "Record shipped successfully") {
                    Swal.fire(
                      '',
                      'The Sales order shipped successfully.',
                      'success'
                    );
                    handleSuccess();
                  }

                }
              } catch (error) {

              }
            }

          });
        }
      }

    }
    else {
      Swal.fire(
        'Error!',
        'Please check at least one record to delete sales order.',
        'warning'
      );
    }
  }

  const handleUnAllocate = async (event, part, index) => {
    event.stopPropagation();
    let ID = 0;
    for (const id of multipleIds) {
      ID = id;
    }
    if (ID > 0) {
      const saleOrderDetail = await fetchSaleOrderDetail(ID);
      if (saleOrderDetail.snt_AllocatedStatus === 0 || saleOrderDetail.snt_AllocatedStatus === null) {
        Swal.fire(
          '',
          'The selected sales order is not allocated.',
          'Warning'
        );
      }
      else {
        if (saleOrderDetail.bit_DropShipment === 2) {
          Swal.fire(
            '',
            'The Selected Sales Order is already shipped',
            'Warning'
          );
        }
        else {
          Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to unallocate this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes!'
          }).then(async (result) => {
            if (result.isConfirmed) {
              try {
                const postData = await SaleOrderService.UnAllocateSaleOrder(ID);
                if (postData.message === "Data saved successfully") {
                  Swal.fire(
                    '',
                    'The Sales order unallocated successfully.',
                    'success'
                  );
                  handleSuccess();
                }
              } catch (error) {

              }
            }

          });
        }
      }

    }
    else {
      Swal.fire(
        'Error!',
        'Please check at least one record to delete sales order.',
        'warning'
      );
    }
  }

  const handleCloseShippmentModal = async () => {
    await fetchSaleOrder(ClientCompanyID, '0', pageSize);
    setShowShippedModal(false);

  };
  const redirecttoUnAuthorzied = () => {
    navigate('/Unauthorized'); // Redirect to the login page
  };
  const IsModuleAssigned = async () => {
    try {
      const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
      };
      const CompanyID = localStorage.getItem("CompanyID");
      if (CompanyID === null || CompanyID === "null") {
        redirectCallback();
      }
      const Modules = await ModuleService.GetModuleByClientID(CompanyID, "7");
      if (Modules.length === 0) {
        Swal.fire(
          'UnAuthorzied Access!',
          'Sorry, You are not authorized to access this module.',
          'warning'
        );
        redirecttoUnAuthorzied();
      }
    } catch (error) {
      console.error('Error fetching Teams:', error);
    }
  };
  const handleSynchronize = async (event) => {
    event.stopPropagation(); // Prevent the row click event
    let ID = 0;
    for (const id of multipleIds) {
      ID = id;
    }

    if (ID) {
      const saleOrderDetail = await fetchSaleOrderDetail(ID);

      if (saleOrderDetail.bit_DropShipment === 2 || saleOrderDetail.bit_DropShipment === "2") {
        if (saleOrderDetail.CustomerGuidID != null && saleOrderDetail.CustomerGuidID != "null") {
          Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, Synchronize!'
          }).then(async (result) => {
            if (result.isConfirmed) {
              try {

                const postData = await SaleOrderService.SyncSaleOrderToFinancial(multipleIds);
                if (postData && postData.message === "Data saved successfully") {
                  Swal.fire(
                    'Success!',
                    'The data has been processed and will be fully synced shortly.',
                    'success'
                  );
                  await fetchSaleOrder(ClientCompanyID, '0', pageSize);
                }
              } catch (error) {
                console.error('Error Synchronizing data:', error);
                Swal.fire(
                  'Error!',
                  'There was a problem in synchronizing the record.',
                  'error'
                );
                await fetchSaleOrder(ClientCompanyID, '0', pageSize);
              }
            }

          });
        }
        else {
          Swal.fire(
            'Error!',
            'Please sync the selected customer with sage account.',
            'warning'
          );
        }
      }
      else {
        Swal.fire(
          'Error!',
          'The selected sales order cannot be synchronize before shippment.',
          'warning'
        );
      }
    }
    else {
      Swal.fire(
        'Error!',
        'Please select at least one record to synchronize.',
        'warning'
      );
    }

  };
  const handlePaySaleOrder = async (event) => {
    event.stopPropagation(); // Prevent the row click event
    if (selectedId > 0 && ClientCompanyID > 0) {

      const saleOrderDetail = await fetchSaleOrderDetail(selectedId);
      if (saleOrderDetail.bit_DropShipment === 2 || saleOrderDetail.bit_DropShipment === "2") {
        Swal.fire({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, Pay it!'
        }).then(async (result) => {
          if (result.isConfirmed) {
            try {
              const SaleOrder = await SaleOrderService.PaySaleOrder(selectedId);
              if (SaleOrder.message === "Data saved successfully") {
                Swal.fire(
                  'Success!',
                  'Sales order paid Successfully.',
                  'success'
                );
                await fetchSaleOrder(ClientCompanyID, '0', pageSize);
              }

            } catch (error) {
            }
          }

        });
      }
      else {
        Swal.fire(
          'Error!',
          'The selected sales order cannot be pay before shippment.',
          'warning'
        );
      }
    }
    else {
      Swal.fire(
        'Error!',
        'Please select the sales order to pay.',
        'warning'
      );
    }

  };
  const handleCustomerSaleOrderRecord = async (event) => {
    event.stopPropagation(); // Prevent the row click event
    const SaleOrder = await SaleOrderService.CustomerSaleOrderRecord(ClientCompanyID);
    setSaleOrderBalance(SaleOrder);
    setIsModalBalance(true);
  };
  const handleStart = (e, ui) => {
    e.stopPropagation();
  }

  const handlePageChange = (page) => {
    setSaleOrderData([]);
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);

    }
  };
  const handlePageSizeChange = (event) => {
    const newPageSize = parseInt(event.target.value, 10);
    setPageSize(newPageSize);
    setPageSizeInCookie(newPageSize);
    setCurrentPage(1); // Reset to the first page
  };
  const handleSearchButtonClick = async () => {
    setCurrentPage(1); // Reset to first page
    setSaleOrderData([]); // Clear previous data
    const query = searchQuery.toLowerCase(); // Use current searchQuery state
    let columnsToSearch = searchColumns.length > 0
      ? searchColumns.join(",")
      : "ALL";
    setSearchOptions(columnsToSearch);
    const purchaseOrderData = await SaleOrderService.GetAllSaleOrder(redirectCallback, ClientCompanyID, currentPage, pageSize.toString(),
      query.toString(), sortConfig.key.toString(), sortConfig.direction.toString(), columnsToSearch.toString());
    setSaleOrderData(purchaseOrderData);

    const soorderCount = await SaleOrderService.GetSaleOrderCount(redirectCallback, ClientCompanyID, searchQuery, columnsToSearch.toString());
    setSOCount(soorderCount[0].TotalRecords);
    setTotalPages(Math.ceil(soorderCount[0].TotalRecords / pageSize)); // Set total pages dynamically

    const searchList = await CustomerService.GetSearchLog("7");
    setRecentSearches(searchList);
  };
  const handleSort = async (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }

    const newConfig = { key, direction };
    setSortConfig(newConfig);
    setSortConfigInCookie(newConfig);
    setCurrentPage(1);

    setSortConfig({ key, direction });
    const sorderData = await SaleOrderService.GetAllSaleOrder(redirectCallback, ClientCompanyID, "1", pageSize.toString(),
      searchQuery.toString(), key.toString(), direction.toString(), searchColumns.toString());

    const sorderCount = await SaleOrderService.GetSaleOrderCount(redirectCallback, ClientCompanyID, searchQuery, searchColumns.toString());

    setSOCount(sorderCount[0].TotalRecords);
    setSaleOrderData(sorderData);

    setTotalPages(Math.ceil(sorderCount[0].TotalRecords / pageSize));
  };

  const defaultColumns = [
    "SorderNo",
    "Stype",
    "ScreatedFrom",
    "SorderDate",
    "SfullName",
    "SSiteName",
    "Sreference",
    "Sallocated",
    "Sshipped",
    "Sprinted",
    "Stotal",
    "Sposted",
    "Spaid",
    "ModifiedBy",

  ];

  const columnOptions = [
    { value: "SorderNo", label: "Order No." },
    { value: "Stype", label: "Type" },
    { value: "ScreatedFrom", label: "Created From" },
    { value: "SorderDate", label: "Order Date" },
    { value: "SfullName", label: "Full Name" },
    { value: "SSiteName", label: "Site" },
    { value: "Semail", label: "Email" },
    { value: "Sreference", label: "Reference" },
    { value: "Sallocated", label: "Allocated" },
    { value: "Sshipped", label: "Shipped" },
    { value: "Sprinted", label: "Printed" },
    { value: "Stotal", label: "	Total" },
    { value: "Sposted", label: "	Posted" },
    { value: "Spaid", label: "	Paid" },
    { value: "UpdatedDate", label: "Updated Date" },
    { value: "AssignTo", label: "AssignTo" },
    { value: "ModifiedBy", label: "ModifiedBy" },


  ];

  const getStoredColumns = () => {
    const storedColumns = Cookies.get(`SaleOrderColumns_${CompanyID}`);
    return storedColumns ? JSON.parse(storedColumns) : columnOptions.map(option => option.value);
  };

  const [visibleColumns, setVisibleColumns] = useState(getStoredColumns());
  const handleColumnChange = (selectedOptions) => {
    setVisibleColumns(selectedOptions);

    // Save selection to cookies (valid for 1 year)
    Cookies.set(`SaleOrderColumns_${CompanyID}`, JSON.stringify(selectedOptions), { expires: 365 });
  };

  const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);
  const [Email, setEmail] = useState();
  const [ContactIDForEmail, setContactIDForEmail] = useState();
  const [isMultipleEmailModalOpen, setIsMultipleEmailModalOpen] = useState(false);
  const [multipleEmails, setMultipleEmails] = useState([]);
  const [lastCheckedIndex, setLastCheckedIndex] = useState(null);
  const handleEmailClick = async (event, contact) => {
    event.stopPropagation();
    setEmail(contact.Email);
    setContactIDForEmail(contact.FK_ClientContact_ID)
    setIsEmailModalOpen(true);
  };
  const handleCloseEmailModal = async () => {
    setIsMultipleEmailModalOpen(false);
    setIsEmailModalOpen(false);
    fetchSaleOrder("0", "0", pageSize);
  };
  const handleSendMultipleEmail = async () => {
    if (multipleIds.length > 0) {

      const emails = multipleIds
        .map(id => {
          const contact = SaleOrderList.find(c => c.PK_SalesOrder_ID === id);
          return contact ? contact.Email : '';
        })
        .filter(email => email);
      setEmail(emails[0]);

      const id = multipleIds[0];
      const currentInputValues = {
        ClientID: localStorage.getItem("CompanyID"),
        ID: id
      };

      const JasperReport = await JasperReportService.GetJasperReportByID("109");
      let url = JasperReport[0].Link;
      debugger;
      Object.keys(currentInputValues).forEach((key) => {
        const placeholder = new RegExp(`{${key}}`, "g");
        url = url.replace(placeholder, currentInputValues[key]);
      });

      const queryObj = {
        ...currentInputValues,
        format: "pdf",
        ReportName: JasperReport[0].ReportName,
        ReportType: JasperReport[0].ReportType,
        name: JasperReport[0].ReportName
      };

      const queryString = new URLSearchParams(queryObj).toString();

      // 🔥 GET PDF as BLOB from API
      const response = await axiosInstance.get(`/Dashboard/ProxyReport?${queryString}`, {
        responseType: "blob",
      });

      // 🔥 Convert Blob → File
      const pdfFile = new File(
        [response.data],
        `${JasperReport[0].ReportName}.pdf`,
        { type: "application/pdf" }
      );

      // 🔥 Save to state (to send email)
      setPdfAttachment(pdfFile);

      // 🔥 Open Email Modal
      setIsMultipleEmailModalOpen(true);
    }
    else {
      Swal.fire('Error!', 'Please check at least one record.', 'warning');
    }
  }
  const handleCheckboxClick = (event, id, index) => {
    event.stopPropagation();

    const isChecked = event.target.checked;

    if (event.shiftKey && lastCheckedIndex !== null) {
      const start = Math.min(lastCheckedIndex, index);
      const end = Math.max(lastCheckedIndex, index);
      const idsInRange = SaleOrderList.slice(start, end + 1).map(l => l.PK_SalesOrder_ID);

      setMultipleIds(prev => {
        const s = new Set(prev);
        if (isChecked) {
          idsInRange.forEach(x => s.add(x));     // range select
        } else {
          idsInRange.forEach(x => s.delete(x));  // range unselect
        }
        return Array.from(s);
      });
    } else {
      // normal single toggle
      setMultipleIds(prev => {
        const s = new Set(prev);
        if (isChecked) s.add(id); else s.delete(id);
        return Array.from(s);
      });
    }

    // Always update the anchor index
    setLastCheckedIndex(index);

  };
  const defaultColumnsForSearch = [
    "SorderNo",
    "Stype",
    "ScreatedFrom",
    "SorderDate",
    "SfullName",
    "SSiteName",
    "Sreference",
    "Sallocated",
    "Sshipped",
    "Sprinted",
    "Stotal",
    "Sposted",
    "Spaid",
    "ModifiedBy"

  ];
  const [searchColumns, setSearchColumns] = useState(defaultColumnsForSearch);
  const [searchOptions, setSearchOptions] = useState(defaultColumnsForSearch);
  const columnSearchOptions = [
    { value: "SorderNo", label: "Order No." },
    { value: "Stype", label: "Type" },
    { value: "ScreatedFrom", label: "Created From" },
    { value: "SorderDate", label: "Order Date" },
    { value: "SfullName", label: "Full Name" },
    { value: "SSiteName", label: "Site" },
    { value: "Semail", label: "Email" },
    { value: "Sreference", label: "Reference" },
    { value: "Sallocated", label: "Allocated" },
    { value: "Sshipped", label: "Shipped" },
    { value: "Sprinted", label: "Printed" },
    { value: "Stotal", label: "	Total" },
    { value: "Sposted", label: "	Posted" },
    { value: "Spaid", label: "	Paid" },
    { value: "ModifiedBy", label: "ModifiedBy" },


  ];
  const handleSearchColumnChange = (selectedOptions) => {
    setSearchColumns(selectedOptions);

  };
  const handleExportExcel = async () => {

    if (multipleIds.length === 0) {
      Swal.fire(
        'Warning!',
        'Please select at least one record to export.',
        'warning'
      );
      return;
    }
    setLoading(true);
    try {

      // Filter only selected customers
      const selectedJob = SaleOrderList.filter(job =>
        multipleIds.includes(job.PK_SalesOrder_ID)
      );

      if (!selectedJob || selectedJob.length === 0) {
        Swal.fire(
          'Warning!',
          'No selected data to export.',
          'warning'
        );
        return;
      }

      const headers = visibleColumns.map(col =>
        columnOptions.find(opt => opt.value === col)?.label || col
      );

      const rows = selectedJob.map(row =>
        visibleColumns.map(col => {
          let value = row[col];
          if (col === "SorderNo") {
            value = `${row.bnt_OrderNumber ?? ""}`;
          }
          if (col === "Stype") {
            value = `${row.vc_Name ?? ""}`;
          }
          if (col === "ScreatedFrom") {
            value = `${row.SaleOrderName ?? ""}`;
          }
          if (col === "SorderDate") {
            value = `${row.dt_SalesOrderDate ?? ""}`;
          }
          if (col === "SfullName") {
            value = `${row.CompanyName ?? ""}`;
          }
          if (col === "Sreference") {
            value = `${row.vc_User7 ?? ""}`;
          }
          if (col === "Sallocated") {
            value = `${row.Allocated ?? ""}`;
          }
          if (col === "Sshipped") {
            value = `${row.Shippment ?? ""}`;
          }
          if (col === "Sprinted") {
            value = `${row.bit_Printed ?? ""}`;
          }
          if (col === "Stotal") {
            value = `${row.Total ?? ""}`;
          }

          return `"${(value ?? '').toString().replace(/"/g, '""')}"`;
        }).join(',')
      );

      const csvContent = [
        headers.join(','), // CSV Header
        ...rows            // CSV Rows
      ].join('\n');

      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'Sales Order.csv');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

    } catch (error) {
      console.error('Error exporting selected customers:', error);
    } finally {
      setLoading(false);
    }
  };

  const [showPdfModal, setShowPdfModal] = useState(false);
  const [imageData, setImageData] = useState(null);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [reportTitle, setReportTitle] = useState('');
  const [reportLink, setReportLink] = useState('');
  const [inputValues, setInputValues] = useState({});
  const [outputData, setOutputData] = useState([]);
  const [error, setError] = useState(null);


  const getMergedPDFBytes = async (id) => {
    try {
      const currentInputValues = {
        ClientID: localStorage.getItem("CompanyID"),
        ID: id
      };

      const redirectCallback = () => navigate('/');

      let reportData = await ReportService.GetCompanyReports(redirectCallback, "7");
      reportData = reportData.filter(x => x.IsDefault.toString() === "1");

      const reportID = reportData.length > 0 ? reportData[0].ID : 109;
      const JasperReport = await JasperReportService.GetJasperReportByID(reportID);

      const queryObjMain = {
        ...currentInputValues,
        format: 'pdf',
        ReportName: JasperReport[0].ReportName,
        ReportType: JasperReport[0].ReportType,
        name: JasperReport[0].ReportName
      };

      const responseMain = await axiosInstance.get(
        `/Dashboard/ProxyReport?${new URLSearchParams(queryObjMain)}`,
        { responseType: 'blob' }
      );

      const mainPdfBytes = await responseMain.data.arrayBuffer();

      const pdfDoc = await PDFDocument.load(mainPdfBytes);

      return pdfDoc;

    } catch (err) {
      console.error(err);
      return null;
    }
  };



  const handlePrintUser = async (event) => {
    event.stopPropagation();

    const result = await Swal.fire({
      title: "Include Terms & Conditions?",
      text: "Do you want to include Terms & Conditions in the print?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, include it",
      cancelButtonText: "No, just main report",
    });
    setLoading(true);
    const includeTerms = result.isConfirmed;

    if (multipleIds.length > 0) {
      try {
        const finalMergedPdf = await PDFDocument.create();

        // ================= MERGE INVOICES =================
        for (const id of multipleIds) {

          const pdfDoc = await getMergedPDFBytes(id);

          if (!pdfDoc) continue;

          const pages = await finalMergedPdf.copyPages(
            pdfDoc,
            pdfDoc.getPageIndices()
          );

          pages.forEach(page => finalMergedPdf.addPage(page));


          // ================= ADD TERMS ONLY ONCE =================
          if (includeTerms) {

            const companySetup = await CompanySetupController.GetCompanyByID(
              () => navigate('/'),
              localStorage.getItem("CompanyID")
            );

            const termFile = companySetup?.[0]?.TermFile;

            if (termFile) {
              const FileUrl = `${BASE_URL}/uploads/${localStorage.getItem('CompanyID')}/Admin/TermConditions/${termFile}`;

              const responseSecond = await axiosInstance.get(FileUrl, {
                responseType: 'blob'
              });

              const secondPdfBytes = await responseSecond.data.arrayBuffer();
              const secondPdf = await PDFDocument.load(secondPdfBytes);

              const secondPages = await finalMergedPdf.copyPages(
                secondPdf,
                secondPdf.getPageIndices()
              );

              secondPages.forEach(page => finalMergedPdf.addPage(page));
            }
          }
        }
        // ================= FINAL OUTPUT =================
        const finalBytes = await finalMergedPdf.save();
        const finalBlob = new Blob([finalBytes], { type: "application/pdf" });

        const finalUrl = URL.createObjectURL(finalBlob);
        setLoading(false);
        setPdfUrl(finalUrl);
        setShowPdfModal(true);

      } catch (err) {
        console.error('Error executing report:', err);
        setError('Failed to execute the report.');
      }
    } else {
      Swal.fire(
        'Error!',
        'Please check at least one record to print job.',
        'warning'
      );
    }
  };

  const getInitialWidths = () => {
    const saved = Cookies.get(`SaleColumnWidths_${CompanyID}_${UserID}`);
    const defaults = {};

    visibleColumns.forEach(col => {
      defaults[col] = 110;
    });

    if (!saved) return defaults;

    const parsed = JSON.parse(saved);
    const applied = {};

    visibleColumns.forEach(col => {
      applied[col] = parsed[col] || 110;
    });

    return applied;
  };

  const [columnWidths, setColumnWidths] = useState(getInitialWidths);
  const startX = useRef(0);
  const startWidth = useRef(0);
  const resizingColumn = useRef(null);
  const MIN_COL_WIDTH = 60;

  /**
   * Load widths from cookie when visibleColumns changes
   */
  useEffect(() => {
    const savedWidths = Cookies.get(`SaleColumnWidths_${CompanyID}_${UserID}`);
    if (savedWidths) {
      const parsed = JSON.parse(savedWidths);
      setColumnWidths((prev) => ({
        ...prev,
        ...parsed
      }));
    }
  }, [SaleOrderList]);


  /**
   * Start Column Resize
   */
  const startResize = (e, key) => {
    e.stopPropagation();
    startX.current = e.clientX;
    resizingColumn.current = key;

    const th = e.target.closest("th");   // FIXED HERE
    startWidth.current = th.offsetWidth;

    document.addEventListener("mousemove", resizeColumn);
    document.addEventListener("mouseup", stopResize);
  };

  /**
   * Resize Column dynamically
   */
  const resizeColumn = (e) => {
    if (!resizingColumn.current) return;

    const delta = e.clientX - startX.current;
    const newWidth = Math.max(startWidth.current + delta, MIN_COL_WIDTH);

    setColumnWidths(prev => ({
      ...prev,
      [resizingColumn.current]: newWidth
    }));
  };
  useEffect(() => {
    setColumnWidths(getInitialWidths());
  }, [visibleColumns]);

  /**
   * Stop resizing and save to cookie
   */
  const stopResize = () => {
    document.removeEventListener("mousemove", resizeColumn);
    document.removeEventListener("mouseup", stopResize);

    const key = resizingColumn.current;
    if (key) {
      setColumnWidths(prev => {
        // Save using the most recent updated state
        Cookies.set(
          `SaleColumnWidths_${CompanyID}_${UserID}`,
          JSON.stringify(prev),
          { expires: 365 }
        );
        return prev;
      });
    }

    resizingColumn.current = null;
  };


  /**
   * Auto-fit column width
   */
  const autoFitColumn = (key) => {
    const cells = document.querySelectorAll(`[data-col='${key}']`);
    let maxWidth = 0;

    cells.forEach(cell => {
      maxWidth = Math.max(maxWidth, cell.scrollWidth);
    });

    const newWidth = maxWidth + 20;

    const updated = { ...columnWidths, [key]: newWidth };

    setColumnWidths(updated);

    Cookies.set(
      `SaleColumnWidths_${CompanyID}_${UserID}`,
      JSON.stringify(updated),
      { expires: 365 }
    );
  };

  const handleInvoice = async (event) => {
    event.stopPropagation(); // Prevent the row click event

    if (multipleIds.length > 0) {
      let ID = 0;
      for (const id of multipleIds) {
        ID = id;
      }
      try {

        const saleOrderDetail = await fetchSaleOrderDetail(ID);

        if (saleOrderDetail.bit_DropShipment === 2 || saleOrderDetail.bit_DropShipment === "2") {
          Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, Synchronize!'
          }).then(async (result) => {
            if (result.isConfirmed) {
              try {

                const postData = await SaleOrderService.CreateInvoiceFromSaleOrder(ID);
                if (postData && postData.message === "Data saved successfully") {
                  Swal.fire(
                    'Success!',
                    'The Invoice has been created successfully.',
                    'success'
                  );
                  await fetchSaleOrder(ClientCompanyID, '0', pageSize);
                }
              } catch (error) {
                console.error('Error Synchronizing data:', error);
                Swal.fire(
                  'Error!',
                  'There was a problem in synchronizing the record.',
                  'error'
                );
                await fetchSaleOrder(ClientCompanyID, '0', pageSize);
              }
            }

          });
        }
        else {
          Swal.fire(
            'Error!',
            'The selected sales order cannot be invoiced before shippment.',
            'warning'
          );
        }


      } catch (err) {
        console.error('Error executing report:', err);
        setError('Failed to execute the report.');
      }

    }
    else {
      Swal.fire(
        'Error!',
        'Please check at least one record to invoice.',
        'warning'
      );
    }
  };
  return (

    <div>
      {ClientCompanyID === 0 && (
        <Common showAddButton={'yes'} handleAddTask={handleCreateSaleOrderClick}
          showShipSaleOrder={'yes'} handleShipSaleOrder={handleAllocateSaleOrder}
          showShippment={'yes'} handleShippment={handleShippment}
          showUnAllocate={'yes'} handleUnAllocate={handleUnAllocate}
          showDeleteButton={'yes'} handleDeleteItem={handleDeleteClick} ModuleID={"7"}

          showEmailButton={'yes'} handleSendEmail={handleSendMultipleEmail}
          showExportButton={'yes'} handleExportExcel={handleExportExcel}
          IsAttachment="1" isDisabled={multipleIds.length > 1}
          showPrintUser={'yes'} handlePrintUser={handlePrintUser}
          showInvoiceButton={'yes'} handleInvoiceCreate={handleInvoice}
          HelpFormName="Sale Order List" HelpModule="8"
          handleShippmentTitle={"Ship"}
          RecordID={multipleIds}
        />


      )}
      {loading && (
        <div class="loading">
          <div class="d-table">
            <div class="d-tablecell">
              <span class="loader">
                <span class="loader-inner"></span>
              </span>
            </div>
          </div>
        </div>
      )}
      <div className="main-content-header">
        <div className="row mb-3" style={{ marginLeft: "-5px" }}>

          {(ClientCompanyID === 0 &&
            <div className="col-xl-2">
              <h1>{t("header")}</h1>
            </div>
          )}
          {(ClientCompanyID > 0 &&
            <div className="col-xl-2">
              <button className='btn btn-primary btn-sm' onClick={handleCreateSaleOrderClick}>
                <i className="icofont-plus" aria-hidden="true"> Add New</i>
              </button>
            </div>
          )}

          <div className="col-xl-10 d-flex justify-content-end">
            <ColumnOptionDropDown
              options={columnOptions}
              selectedOptions={visibleColumns}
              onChange={handleColumnChange}
            />

            {(ClientCompanyID > 0 &&
              <>
                <button style={{ padding: "5px 8px", marginRight: "5px" }} className='btn btn-success' onClick={handlePaySaleOrder}>
                  {t('pay')}
                </button>
                <button style={{ padding: "5px 8px", marginRight: "5px" }} className='btn btn-secondary' onClick={handleCustomerSaleOrderRecord}>
                  {t('balance')}
                </button>


              </>
            )}
          </div>

        </div>
      </div>
      <div className="row">
        <div className="col-xl-12">
          <div className="card mb-30">
            <div className="card-body">

              <div className="table-responsive" style={{ overflow: "visible" }}>
                <div className="row mb-3">
                  <div className="col-sm-1">
                    <select id="pageSize" className="form-control" value={pageSize} onChange={handlePageSizeChange}>
                      <option value={10}>10</option>
                      <option value={25}>25</option>
                      <option value={50}>50</option>
                      <option value={100}>100</option>
                      <option value={500}>500</option>
                      <option value={1000}>1000</option>
                    </select>
                  </div>
                  <label style={{ paddingLeft: "0px" }} className="col-sm-2" htmlFor="pageSize">entries per page: </label>
                  <div className="col-sm-6"></div>
                  <div className="col-sm-1 d-flex align-items-center justify-content-end">
                    <span className="me-2">Search</span>

                    <MultiSearchDropDown
                      options={columnSearchOptions}
                      selectedOptions={searchColumns}
                      onChange={handleSearchColumnChange}
                    />
                  </div>
                  <div className="col-sm-2 d-flex justify-content-end">
                    <input
                      list="recent-searches"
                      type="text"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      className="form-control me-2"
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                          handleSearchButtonClick();
                        }
                      }}
                    />
                    <datalist id="recent-searches">
                      {recentSearches.map((item, idx) => (
                        <option key={idx} value={item.SearchQuery} />
                      ))}
                    </datalist>
                    <button onClick={() => handleSearchButtonClick()} style={{ background: "none", border: "none" }}>
                      <img src="assets/img/resources/search.png" class="top-icon" alt="Add icon" />
                    </button>
                  </div>



                </div>
                <div style={{ maxHeight: "80vh", overflow: "auto" }}>
                  <table
                    style={{
                      tableLayout: "fixed",
                      width: "max-content",
                      minWidth: "100%"
                    }}
                    className="table m-0 table-hover"
                    ref={tableRef}
                  >
                    <thead classname="table-light" style={{ position: "sticky", top: 0, zindex: 2 }}>
                      <tr>
                        <th
                          className="checkbox-header"
                          style={{
                            width: "40px",
                            minWidth: "40px",
                            maxWidth: "40px",
                            position: "sticky",
                            left: 0,
                            zIndex: 5,

                          }}
                        ></th>
                        {visibleColumns.includes("SorderNo") &&
                          <th onClick={() => handleSort('PK_SalesOrder_ID')}

                            style={{
                              width: `${columnWidths?.PK_SalesOrder_ID}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">{t('orderNo')}
                            <i
                              className={`ms-1 icofont ${sortConfig.key === 'PK_SalesOrder_ID'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i><div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "PK_SalesOrder_ID");
                              }}
                              onDoubleClick={() => autoFitColumn("PK_SalesOrder_ID")}
                            />
                          </th>
                        }
                        {visibleColumns.includes("Stype") &&
                          <th onClick={() => handleSort('vc_Name')}

                            style={{
                              width: `${columnWidths?.vc_Name}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">{t('type')}
                            <i
                              className={`ms-1 icofont ${sortConfig.key === 'vc_Name'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i><div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "vc_Name");
                              }}
                              onDoubleClick={() => autoFitColumn("vc_Name")}
                            />
                          </th>
                        }
                        {visibleColumns.includes("ScreatedFrom") &&
                          <th onClick={() => handleSort('createdFrom')}

                            style={{
                              width: `${columnWidths?.createdFrom}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">{t('createdFrom')}
                            <i
                              className={`ms-1 icofont ${sortConfig.key === 'createdFrom'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i><div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "createdFrom");
                              }}
                              onDoubleClick={() => autoFitColumn("createdFrom")}
                            />
                          </th>
                        }
                        {visibleColumns.includes("SorderDate") &&
                          <th onClick={() => handleSort('dt_SalesOrderDate')}

                            style={{
                              width: `${columnWidths?.dt_SalesOrderDate}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">{t('orderDate')}
                            <i
                              className={`ms-1 icofont ${sortConfig.key === 'dt_SalesOrderDate'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i><div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "dt_SalesOrderDate");
                              }}
                              onDoubleClick={() => autoFitColumn("dt_SalesOrderDate")}
                            />
                          </th>
                        }
                        {visibleColumns.includes("SfullName") &&
                          <th onClick={() => handleSort('CompanyName')}

                            style={{
                              width: `${columnWidths?.CompanyName}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">Company
                            <i
                              className={`ms-1 icofont ${sortConfig.key === 'CompanyName'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i><div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "CompanyName");
                              }}
                              onDoubleClick={() => autoFitColumn("CompanyName")}
                            />
                          </th>
                        }
                        {visibleColumns.includes("SSiteName") &&
                          <th onClick={() => handleSort('SiteName')}

                            style={{
                              width: `${columnWidths?.SiteName}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">Site
                            <i
                              className={`ms-1 icofont ${sortConfig.key === 'SiteName'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i><div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "SiteName");
                              }}
                              onDoubleClick={() => autoFitColumn("SiteName")}
                            />
                          </th>
                        }
                        {visibleColumns.includes("Semail") && <th

                          style={{
                            width: `${columnWidths?.Email}px`,
                            minWidth: `${MIN_COL_WIDTH}px`
                          }}
                          className="resizable ellipsis">Email</th>}
                        {visibleColumns.includes("Sreference") &&
                          <th onClick={() => handleSort('vc_User7')}

                            style={{
                              width: `${columnWidths?.vc_User7}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">{t('reference')}
                            <i
                              className={`ms-1 icofont ${sortConfig.key === 'vc_User7'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i><div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "vc_User7");
                              }}
                              onDoubleClick={() => autoFitColumn("vc_User7")}
                            />
                          </th>
                        }
                        {visibleColumns.includes("Sallocated") && <th

                          style={{
                            width: `${columnWidths?.allocated}px`,
                            minWidth: `${MIN_COL_WIDTH}px`
                          }}
                          className="resizable ellipsis">{t('allocated')}<div
                            className="resize-handle"
                            onMouseDown={(e) => {
                              e.stopPropagation();   // STOP the click event from bubbling
                              startResize(e, "allocated");
                            }}
                            onDoubleClick={() => autoFitColumn("allocated")}
                          /></th>}
                        {visibleColumns.includes("Sshipped") && <th

                          style={{
                            width: `${columnWidths?.Sshipped}px`,
                            minWidth: `${MIN_COL_WIDTH}px`
                          }}
                          className="resizable ellipsis">{t('shipped')}<div
                            className="resize-handle"
                            onMouseDown={(e) => {
                              e.stopPropagation();   // STOP the click event from bubbling
                              startResize(e, "Sshipped");
                            }}
                            onDoubleClick={() => autoFitColumn("Sshipped")}
                          /></th>}
                        {visibleColumns.includes("Sprinted") && <th

                          style={{
                            width: `${columnWidths?.printed}px`,
                            minWidth: `${MIN_COL_WIDTH}px`
                          }}
                          className="resizable ellipsis">{t('printed')}<div
                            className="resize-handle"
                            onMouseDown={(e) => {
                              e.stopPropagation();   // STOP the click event from bubbling
                              startResize(e, "printed");
                            }}
                            onDoubleClick={() => autoFitColumn("printed")}
                          /></th>}
                        {visibleColumns.includes("Stotal") && <th

                          style={{
                            width: `${columnWidths?.total}px`,
                            minWidth: `${MIN_COL_WIDTH}px`
                          }}
                          className="resizable ellipsis">{t('total')}<div
                            className="resize-handle"
                            onMouseDown={(e) => {
                              e.stopPropagation();   // STOP the click event from bubbling
                              startResize(e, "total");
                            }}
                            onDoubleClick={() => autoFitColumn("total")}
                          /></th>}
                        {visibleColumns.includes("Sposted") && <th

                          style={{
                            width: `${columnWidths?.posted}px`,
                            minWidth: `${MIN_COL_WIDTH}px`
                          }}
                          className="resizable ellipsis">{t('posted')}<div
                            className="resize-handle"
                            onMouseDown={(e) => {
                              e.stopPropagation();   // STOP the click event from bubbling
                              startResize(e, "posted");
                            }}
                            onDoubleClick={() => autoFitColumn("posted")}
                          /></th>}
                        {visibleColumns.includes("AssignTo") &&
                          <th onClick={() => handleSort('AssignTo')}

                            style={{
                              width: `${columnWidths?.AssignTo}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">Assign To
                            <i
                              className={`ms-1 icofont ${sortConfig.key === 'AssignTo'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i><div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "AssignTo");
                              }}
                              onDoubleClick={() => autoFitColumn("AssignTo")}
                            />
                          </th>
                        }
                        {visibleColumns.includes("UpdatedDate") &&
                          <th onClick={() => handleSort('UpdatedDate')}

                            style={{
                              width: `${columnWidths?.UpdatedDate}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">Last Action
                            <i
                              className={`ms-1 icofont ${sortConfig.key === 'UpdatedDate'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i><div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "UpdatedDate");
                              }}
                              onDoubleClick={() => autoFitColumn("UpdatedDate")}
                            />
                          </th>
                        }
                        {visibleColumns.includes("ModifiedBy") &&
                          <th onClick={() => handleSort('ModifiedBy')}
                            style={{
                              width: `${columnWidths?.ModifiedBy}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">Modified By
                            <i
                              className={`ms-1 icofont ${sortConfig.key === 'ModifiedBy'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i>
                            <div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "ModifiedBy");
                              }}
                              onDoubleClick={() => autoFitColumn("ModifiedBy")}
                            />
                          </th>
                        }
                        {visibleColumns.includes("Spaid") && <th

                          style={{
                            width: `${columnWidths?.paid}px`,
                            minWidth: `${MIN_COL_WIDTH}px`
                          }}
                          className="resizable ellipsis">{t('paid')}<div
                            className="resize-handle"
                            onMouseDown={(e) => {
                              e.stopPropagation();   // STOP the click event from bubbling
                              startResize(e, "paid");
                            }}
                            onDoubleClick={() => autoFitColumn("paid")}
                          /></th>}

                      </tr>
                    </thead>
                    <tbody>
                      {SaleOrderList.map((saleOrder, index) => (

                        <tr key={saleOrder.PK_SalesOrder_ID}
                          onClick={() => handleEditClick(saleOrder.PK_SalesOrder_ID)}
                          style={{
                            backgroundColor: selectedId.toString() === saleOrder.PK_SalesOrder_ID.toString() ? 'rgb(197, 218, 237)' : '', // Highlight background
                            cursor: 'pointer',
                          }}>
                          <td
                            className="checkbox-cell"
                            onClick={(e) => e.stopPropagation()}
                            style={{
                              width: "40px",
                              minWidth: "40px",
                              maxWidth: "40px",
                              position: "sticky",
                              left: 0,
                              zIndex: 3,
                              backgroundColor:
                                selectedId.toString() === saleOrder.PK_SalesOrder_ID.toString()
                                  ? 'rgb(197, 218, 237)'
                                  : '#fff'
                            }}
                          >
                            <div
                              className="checkbox-hover-area"
                              onClick={(event) => handleCheckboxClick(event, saleOrder.PK_SalesOrder_ID, index)}
                            >
                              <input
                                type="checkbox"
                                checked={multipleIds.includes(saleOrder.PK_SalesOrder_ID)}
                                readOnly
                              />
                            </div>
                          </td>
                          {visibleColumns.includes("SorderNo") && <td style={{
                            width: columnWidths.SorderNo,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis">{saleOrder.bnt_OrderNumber}</td>}
                          {visibleColumns.includes("Stype") && <td style={{
                            width: columnWidths.Stype,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis" title={saleOrder.vc_Name}>{saleOrder.vc_Name}</td>}
                          {visibleColumns.includes("ScreatedFrom") && <td style={{
                            width: columnWidths.ScreatedFrom,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis" title={saleOrder.SaleOrderName}>{saleOrder.SaleOrderName}</td>}
                          {visibleColumns.includes("SorderDate") && <td style={{
                            width: columnWidths.SorderDate,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis">{formatDate(saleOrder.dt_SalesOrderDate)}</td>}
                          {visibleColumns.includes("SfullName") && <td style={{
                            width: columnWidths.SfullName,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis" title={saleOrder.CompanyName}>{saleOrder.CompanyName}</td>}

                          {visibleColumns.includes("SSiteName") && <td style={{
                            width: columnWidths.SSiteName,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis" title={saleOrder.SiteName}>{saleOrder.SiteName}</td>}


                          {visibleColumns.includes("Semail") && <td style={{
                            width: columnWidths.Semail,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis" title={saleOrder.Email}>
                            <a href='#' onClick={(event) => handleEmailClick(event, saleOrder)}>
                              {saleOrder.Email}
                            </a>
                          </td>}
                          {visibleColumns.includes("Sreference") && <td style={{
                            width: columnWidths.Sreference,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis" title={saleOrder.vc_User7}>{saleOrder.vc_User7}</td>}
                          {visibleColumns.includes("Sallocated") && <td style={{
                            width: columnWidths.Sallocated,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis" title={saleOrder.Allocated}>{saleOrder.Allocated}</td>}
                          {visibleColumns.includes("Sshipped") && <td style={{
                            width: columnWidths.Sshipped,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis" title={saleOrder.Shippment}>{saleOrder.Shippment}</td>}
                          {visibleColumns.includes("Sprinted") && <td style={{
                            width: columnWidths.Sprinted,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis">{saleOrder.bit_Printed}</td>}
                          {visibleColumns.includes("Stotal") && <td style={{
                            width: columnWidths.Stotal,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis"> {saleOrder.BaseCurrency}{parseFloat(saleOrder.Total).toFixed(2)}</td>}
                          {visibleColumns.includes("Sposted") && <td></td>}
                          {visibleColumns.includes("AssignTo") && <td style={{
                            width: columnWidths.AssignTo,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis">
                            {saleOrder.AssignTo ? (
                              <div
                                title={saleOrder.AssignTo}
                                style={{
                                  display: "inline-flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  width: "25px",
                                  height: "25px",
                                  borderRadius: "50%",
                                  backgroundColor: "#007bff",
                                  color: "white",
                                  fontWeight: "bold",
                                  fontSize: "14px",
                                }}
                              >
                                {saleOrder.AssignTo.split(" ")
                                  .map(word => word.charAt(0).toUpperCase())
                                  .join("")}
                              </div>
                            ) : (
                              ""
                            )}
                          </td>}
                          {visibleColumns.includes("UpdatedDate") && <td style={{
                            width: columnWidths.UpdatedDate,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis">{formatDateWithFns(saleOrder.UpdatedDate, activeDateFormat)}  </td>}
                          {visibleColumns.includes("ModifiedBy") && <td style={{
                            width: columnWidths.ModifiedBy,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis">
                            {saleOrder.ModifiedBy ? (
                              <div
                                title={saleOrder.ModifiedBy}
                                style={{
                                  display: "inline-flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  width: "25px",
                                  height: "25px",
                                  borderRadius: "50%",
                                  backgroundColor: "#368938",
                                  color: "white",
                                  fontWeight: "bold",
                                  fontSize: "14px",
                                }}
                              >
                                {saleOrder.ModifiedBy.split(" ")
                                  .map(word => word.charAt(0).toUpperCase())
                                  .join("")}
                              </div>
                            ) : (
                              ""
                            )}
                          </td>}
                          {visibleColumns.includes("Spaid") &&
                            <td style={{
                              width: columnWidths.Spaid,
                              minWidth: MIN_COL_WIDTH,
                            }} className="no-wrap ellipsis">
                              {saleOrder.bit_Paid === 1 && (
                                <img src='assets/img/resources/tick.png' style={{ width: "20px" }}></img>
                              )}

                            </td>
                          }



                        </tr>
                      ))}
                    </tbody>
                    <tfoot style={{ position: "sticky", bottom: 0, zIndex: 2, backgroundColor: "white" }}>
                      <tr>
                        <td colSpan={visibleColumns.length + 1}>
                          <div className="pagination-controls" style={{ marginTop: "10px", marginBottom: "10px" }}>
                            Showing {1 + (currentPage * pageSize) - pageSize} to {currentPage * (Math.min(soCount, pageSize))} of {soCount} entries

                            {/* Last Page Button */}
                            <button
                              style={{ float: "right", marginLeft: "5px" }}
                              className='btn btn-info'
                              onClick={() => handlePageChange(totalPages)} // Navigate to last page
                              disabled={currentPage === totalPages}
                            >
                              <img src="assets/img/resources/last.png" alt="Add icon" style={{ height: "10px" }} /> Last
                            </button>

                            {/* Next Page Button */}
                            <button
                              style={{ float: "right", marginLeft: "5px" }}
                              className='btn btn-info'
                              onClick={() => handlePageChange(currentPage + 1)}
                              disabled={currentPage === totalPages}
                            >
                              <img src="assets/img/resources/next-icon.png" alt="Add icon" style={{ height: "10px" }} /> Next
                            </button>

                            <span style={{ marginLeft: "10px", marginRight: "10px", float: "right" }}>
                              Page {currentPage} of {totalPages}
                            </span>

                            {/* Previous Page Button */}
                            <button
                              style={{ float: "right", marginRight: "5px", marginLeft: "5px" }}
                              className='btn btn-info'
                              onClick={() => handlePageChange(currentPage - 1)}
                              disabled={currentPage === 1}
                            >
                              <img src="assets/img/resources/pevious-icon.png" alt="Add icon" style={{ height: "10px" }} />  Prev
                            </button>

                            {/* First Page Button */}
                            <button
                              style={{ float: "right" }}
                              className='btn btn-info'
                              onClick={() => handlePageChange(1)} // Navigate to first page
                              disabled={currentPage === 1}
                            >
                              <img src="assets/img/resources/first.png" alt="Add icon" style={{ height: "10px" }} /> First
                            </button>
                          </div>
                        </td>
                      </tr>
                    </tfoot>
                  </table>


                  {/* Page Size Selector */}


                  {isModalBalance && (
                    <div className="modal fade show d-block" tabIndex="-1">
                      <div className="modal-dialog modal-lg">
                        <Draggable handle=".modal-content" onStart={handleStart}>
                          <div className="modal-content">
                            <div className="modal-header">
                              <h5 className="modal-title">Customer Balance</h5>
                              <button type="button" className="close" onClick={() => setIsModalBalance(false)}>
                                <span>&times;</span>
                              </button>
                            </div>
                            <div className="modal-body">
                              <div className="row mb-3" style={{ "marginLeft": "0px", marginTop: "10px" }}>
                                <label htmlFor="Balance" className="col-sm-2 col-form-label">Balance :</label>
                                <div className="col-sm-4">
                                  <input type="text" className="form-control" name="Balance" value={SaleOrderBalance.UnpaidTotal} />

                                </div>
                                <label htmlFor="PaidTotal" className="col-sm-2 col-form-label">Amount Paid :</label>
                                <div className="col-sm-4">
                                  <input type="text" className="form-control" name="PaidTotal" value={SaleOrderBalance.PaidTotal} />

                                </div>
                              </div>
                            </div>
                          </div>
                        </Draggable>
                      </div>
                    </div>
                  )}
                </div>
                {isModalOpen && (
                  <SaleOrderDetailModal SaleOrderID={localStorage.getItem('SaleOrderID')} onClose={handleCloseModal} onSuccess={fetchSaleOrder} ClientCompanyID={ClientCompanyID} />
                )}
                {showShippedModal && bnt_OrderNumber &&
                  <SaleOrderShippedModel
                    show={showShippedModal}
                    OnSuccess={handleSuccess}
                    onClose={handleCloseShippmentModal}
                    parts={partList}
                    setParts={setPartData}
                    bnt_OrderNumber={bnt_OrderNumber}
                    saleOrderId={saleOrderId}


                  />
                }
              </div>
            </div>
          </div>
        </div>
      </div>
      {isEmailModalOpen && (
        <SendEmail onClose={handleCloseEmailModal} ToEmail={Email} Module="Customer" ModuleID={ContactIDForEmail} />
      )}
      {isMultipleEmailModalOpen && (
        <SendAttachment onClose={handleCloseEmailModal} ToEmail={Email} pdfAttachment={pdfAttachment} ReportName="SalesOrder.pdf" />
      )}
      {showPdfModal && pdfUrl && (
        <div className="modal fade show d-block" tabIndex="-1">
          <div className="modal-dialog modal-lg">
            <Draggable handle=".modal-content" onStart={handleStart}>
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">PDF Report</h5>
                  <button type="button" className="close" onClick={() => setShowPdfModal(false)}>
                    <span>&times;</span>
                  </button>
                </div>
                <div className="modal-body">
                  <embed src={pdfUrl} type="application/pdf" width="100%" height="600px" />
                </div>
              </div>
            </Draggable>
          </div>
        </div>
      )}



    </div>


  );
}
export default SaleOrderList;

